module.exports = __webpack_public_path__ + "media/images/emblems/Emblem_village_Wigoltingen-d4dd05481e589b7c98dceef2c0865a94.png";